module.exports = __webpack_public_path__ + "media/images/iconPlus__okGreen--dark-1b46d2836ba637dbb0ae4cba640033cd.png";